import { observable } from "mobx";
import { observer } from "mobx-react";
import * as moment from "moment";
import * as React from "react";
import { AppStore } from "../../stores/AppStore";
import { EmpresaStore } from "../../stores/empresa/EmpresaStore";
import { PerfilStore } from "../../stores/perfil/PerfilStore";
import { IconButton } from "@mui/material";
require("../../assets/css/components/Header.css");

@observer
export default class HeaderTarja extends React.Component<any, any> {

  obs = observable({
    visivel: true
  })

  componentDidMount() {
  }

  render() {
    let contaPermissao = AppStore.obs1.usuario ? AppStore.obs1.usuario.conta.teste : false;
    let teste = AppStore.obs1.usuario ? AppStore.obs1.usuario.conta.teste : false;
    let libera_pagamento = AppStore.obs1.usuario ? AppStore.obs1.usuario.conta.libera_pagamento : false;

    if (contaPermissao) {
      let dataCriacao = AppStore.obs1.usuario.conta.inserted_at;
      var proximaCobranca = new Date(new Date(dataCriacao).getTime() + 5 * 24 * 60 * 60 * 1000);

      let dataFat = proximaCobranca;
      let today = moment(new Date());
      var duration = moment.duration(today.diff(dataFat));
      var dias_testes = Math.floor(duration.asDays());

      var duracao = moment.duration(today.diff(dataCriacao));
      var vencimento_teste = Math.floor(duracao.asDays());
    }

    let statusAssi = AppStore.obs1.usuario ? AppStore.obs1.usuario.conta.fatura_ativacao : "";

    let dias: number = 0;
    let data_vencimento_fatura: string = "";

    if (AppStore.obs1.usuario) {
      if (AppStore.obs1.usuario.conta.iugu_fatura != null) {

        if (Object.values(AppStore.obs1.usuario.conta.iugu_fatura).length >= 1) {

          if (AppStore.obs1.usuario.conta.iugu_fatura["status"] != "paid" && AppStore.obs1.usuario.conta.iugu_fatura["status"] != "externally_paid") {

            data_vencimento_fatura = AppStore.obs1.usuario.conta.iugu_fatura["data_fatura"];

            let today = moment(new Date());

            var duration = moment.duration(today.diff(data_vencimento_fatura));
            dias = Math.floor(duration.asDays());

            if (dias > 7 && !libera_pagamento) {
              AppStore.setLocation("/pendente")
            }
          } else {
            libera_pagamento = true;
          }
        } else {
          dias = -4;
        }
      } else {
        dias = -4;
      }
    }

    let iugu_pagamento: boolean = true

    if (typeof AppStore.obs1.usuario.conta.fatura_ativacao == 'string') {
      iugu_pagamento = false
    }

    const msg_vencimento_fatura = () => {

      if (AppStore.obs1.usuario && AppStore.obs1.usuario.admin) {

        return <></>

      } else if (libera_pagamento) {

        return msg_contrato_pendente()

      } else {

        if (dias == -1) {

          add_class_name()

          return (<div className="FaturaVence">
            {PerfilStore.obs.boletos_pendentes.length > 0 ?
              <>
                {PerfilStore.obs.boletos_pendentes?.map(el => {
                  return (
                    <p>
                      Sua assinatura expira em 1 dia. Realize o pagamento antes do vencimento. {" "}
                      <b><a target="_blank" href={el.url}>Visualizar fatura {el.vencimento}</a></b>
                    </p>
                  );
                })}
              </>
              : "Sua assinatura expira em 1 dia. Realize o pagamento antes do vencimento."}
          </div>
          );

        } else if (dias == 0) {
          add_class_name()

          return (<div className="FaturaVence">
            {PerfilStore.obs.boletos_pendentes.length > 0 ?
              <>
                {PerfilStore.obs.boletos_pendentes?.map(el => {
                  return (
                    <p>
                      Sua assinatura expira hoje. Realize o pagamento antes do vencimento. {" "}
                      <b><a target="_blank" href={el.url}>Visualizar fatura {el.vencimento}</a></b>
                    </p>
                  );
                })}
              </>
              : "Sua assinatura expira hoje. Realize o pagamento antes do vencimento."}
          </div>
          );

        } else if (dias > 0) {
          return (
            <div className="FaturaExpirada">
              {PerfilStore.obs.boletos_pendentes.length > 0 ?
                <>
                  {PerfilStore.obs.boletos_pendentes?.map(el => {
                    return (
                      <p>
                        Sua assinatura expirou. O acesso à sua conta será suspenso em breve. Por favor, regularize sua fatura. {" "}
                        <b><a target="_blank" href={el.url} style={{color: "#000"}}>Visualizar fatura {el.vencimento}</a></b>
                      </p>
                    );
                  })}
                </>
                : "Sua assinatura expirou. O acesso à sua conta será suspenso em breve. Por favor, regularize sua fatura."}
            </div>
          );
        }
        return msg_contrato_pendente()
      }
    }

    function msg_status_assinatura() {
      if (!iugu_pagamento && vencimento_teste > 5) {
        return (
          <div className="FixedTeste">
            <p>
              Aguardando a confirmação do pagamento para ativar sua conta na Fipo. {" "}
            </p>
          </div>
        );
      } else if (statusAssi != null) {
        add_class_name()

        return (
          <>
            <div className="FixedTeste FixedPagamento">
              <p>
                Em alguns minutos o usuário princial da conta recebera um e-mail com o boleto. Após efetuar o pagamento será necessário aguardar até 3 dias úteis.
              </p>
            </div>
          </>
        )
      } else {
        add_class_name()
        return (
          <div className="FixedTeste">
            {dias_testes == 0
              ? (
                <p>
                  Seu período de testes termina hoje.{" "}
                  <a onClick={() => AppStore.setLocation("/selecionar-planos")} role="button">
                    Etapa 1: Selecionar seu plano!
                  </a>
                  {" "}
                  <a onClick={() => AppStore.setLocation("/assinar-plano")} role="button">
                    Etapa 2: Ativar seu plano!
                  </a>
                </p>
              )
              : (
                <p>
                  {dias_testes > 5 ?
                    (
                      <>
                        Seu período de testes terminou. {" "}
                        <a onClick={() => AppStore.setLocation("/selecionar-planos")} role="button">
                          Etapa 1: Selecionar seu plano!
                        </a>
                        {" "}/{" "}
                        <a onClick={() => AppStore.setLocation("/assinar-plano")} role="button">
                          Etapa 2: Ativar seu plano!
                        </a>
                      </>
                    )
                    :
                    (
                      <>
                        Seu período de testes termina dia{" "}{moment(proximaCobranca).format("DD/MM/YYYY")},
                        {" "}
                        <a onClick={() => AppStore.setLocation("/selecionar-planos")} role="button">
                          Etapa 1: Selecionar seu plano!
                        </a>
                        {" "}/{" "}
                        <a onClick={() => AppStore.setLocation("/assinar-plano")} role="button">
                          Etapa 2: Ativar seu plano!
                        </a>
                      </>
                    )
                  }
                </p>
              )}
          </div>
        )
      }
    }

    function msg_contrato_pendente() {
      if (!PerfilStore.obs.contrato_assinado) {
        add_class_name()
        return (
          <div className="FixedTeste">
            <>
              Assinatura do seu contrato está pendente. {" "}
              <a onClick={() => AppStore.setLocation("/assinar-contrato")} role="button">
                Clique aqui para assinar!
              </a>{" "}
            </>
          </div>
        )
      }
    }

    function valida_tarja() {

      if (teste) {
        return msg_status_assinatura()
      }

      return msg_vencimento_fatura()

    }

    const add_class_name = () => {

      if (document.getElementById("nav_bar1")) {
        document.getElementById("nav_bar1").classList.add("TarjaMargin")
      }

      if (document.getElementById("nav_bar2")) {
        document.getElementById("nav_bar2").classList.add("TarjaMargin")
      }

    }

    const TarjaModoTeste = () => {

      if (window.location.hostname == "app.fipo.com.br") return null;

      if (!this.obs.visivel) return null;

      let texto = "MODO DESENVOLVIMENTO"

      if(window.location.hostname == "appteste.fipo.com.br"){
        texto = "MODO TESTE"
      }

      return (
        <div className="TarjaTeste">
          <p style={{letterSpacing: 0.5}}>⚠️&nbsp;&nbsp;Você está acessando o sistema em <b>{texto}</b></p>
          <button className="FecharTarja" onClick={() => this.obs.visivel = false}>×</button>
        </div>
      );
    }

    return (
      <>
        {valida_tarja()}
        {TarjaModoTeste()}
      </>
    );
  }
}
